module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_library.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_library.js
// module chunks = 168707334958949